import React, { FC, useEffect } from 'react';
import { Button, Form, Input, Modal, Space } from 'antd';
import { IModal } from 'common/models/model.interface';
import { FormWrapper } from 'common/components/form-wrapper/form-wrapper';
import rentalReservationService from 'common/services/rental-reservation-service/rental-reservation.service';
import { ReactComponent as RejectIcon } from 'assets/icons/reject.svg';
import { notification } from 'common/utils/notification';
import styles from '../rental-portal.module.scss';
import { rejectRentalReservationValidation } from './reject-rental-reservation.validation';

const initValues = {
  comment: '',
};

const RejectRentalReservationModal: FC<IModal<{ reservationId: number }, any>> = ({ isOpen, onClose, title, initData }) => {
  const [form] = Form.useForm();

  const hideModal = (isSuccess: boolean) => {
    form.resetFields();
    notification.destroy();
    if (onClose) {
      onClose(isSuccess);
    }
  };

  const onFinish = async (values: any) => {
    if (!initData?.reservationId) {
      console.error('Rental reservation id is empty');
      return;
    }

    await rentalReservationService.reject(initData.reservationId, { comment: values.comment });
    hideModal(true);
  };

  useEffect(() => {
    if (form && isOpen) {
      form.setFieldsValue(initValues);
    }
  }, [isOpen, form, initData]);

  return (
    <Modal centered title={title} width={750} open={isOpen} wrapClassName="custom-modal" closable={false}>
      <FormWrapper form={form} onFinish={onFinish} initialValues={initValues} layout="vertical">
        <Form.Item name="comment" label="Comment" rules={rejectRentalReservationValidation.comment}>
          <Input.TextArea rows={4} maxLength={1000} className={styles.modalTextArea} placeholder="Describe the reason for rejection" />
        </Form.Item>
        <Space className="footer">
          <Button type="link" onClick={() => hideModal(false)} className={styles.modalButton}>
            Cancel
          </Button>
          <Button type="primary" htmlType="submit" icon={<RejectIcon />} className={`${styles.rejectButton} ${styles.modalButton}`} danger>
            Reject
          </Button>
        </Space>
      </FormWrapper>
    </Modal>
  );
};

export default React.memo(RejectRentalReservationModal, (prevProps, nextProps) => {
  return prevProps.isOpen === nextProps.isOpen;
});
